import SignUp2Container from "../../../components/pages/other/SignUp2";

const SignUp2 = () => {
  return <SignUp2Container />;
};

export default SignUp2;
